import { Grid2 } from "@mui/material";
import React from "react";
import { useSearchParams } from "react-router";
import FormDateField from "../../../../component/form/FormDateField";
import FormDropDown from "../../../../component/form/FormDropDown";
import FormTelInput from "../../../../component/form/FormTelInput";
import FormTextField from "../../../../component/form/FormTextField";
import ManageCities from "./ManageCities";

export default function PersonalDetails({ control, watch }) {
  const [searchParams] = useSearchParams();
  const userParam = searchParams.get("user");
  return (
    <>
      {!userParam && (
        <Grid2 size={{ xs: 12, lg: 6 }}>
          <FormTextField
            placeholder="Guardian's name"
            label="Guardian's name"
            fieldname="guardianName"
            control={control}
            required
            onlyText
          />
        </Grid2>
      )}
      <Grid2 size={{ xs: 12, lg: 6 }}>
        <FormTextField
          placeholder="Patient's name"
          label="Patient's name"
          fieldname="patientName"
          control={control}
          required
          onlyText
        />
      </Grid2>

      <Grid2 size={{ xs: 12, lg: 6 }}>
        <FormDropDown
          label="Patient's gender"
          fieldname="gender"
          control={control}
          required
          dropdownValues={[
            { label: "Male", value: "m" },
            { label: "Female", value: "f" },
          ]}
        />
      </Grid2>

      <Grid2 size={{ xs: 12, lg: 6 }}>
        <FormDateField
          label="Patient's date of birth"
          fieldname="dateOfBirth"
          control={control}
          required
        />
      </Grid2>

      <Grid2 size={{ xs: 12, lg: 6 }}>
        <FormTelInput
          label="Guardian's phone no"
          fieldname="phoneNumber"
          required
          control={control}
        />
      </Grid2>
      {!userParam && (
        <Grid2 size={{ xs: 12, lg: 6 }}>
          <FormTextField
            placeholder="Email address"
            label="Guardian's email"
            fieldname="email"
            control={control}
            required
            rules={{
              pattern: {
                value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i,
                message: "Invalid email",
              },
            }}
          />
        </Grid2>
      )}

      <ManageCities control={control} watch={watch} />
      <Grid2 size={{ xs: 12, lg: 6 }}>
        <FormTextField
          placeholder="Address"
          label="Address"
          fieldname="address1"
          control={control}
          required
        />
      </Grid2>
    </>
  );
}
